import React, { useContext } from 'react'
import { Button, Icon } from 'semantic-ui-react'

import GlobalContext from '../../../contexts/GlobalContext'
import Utility from '../../../Utility'
import AmountProvider from '../../Provider/AmountProvider'

type Props = {
  booking: any;
  handleClickAllDetails: any;
  totalPrice: number;
};

const BookingPriceInfos = ({
  booking,
  handleClickAllDetails,
  totalPrice,
}: Props) => {
  const [globalContext] = useContext(GlobalContext) as any;

  return (
    <>
      {/* REMISE */}
      {booking.totalRemise !== 0 && (
        <div className="d-flex mb-3 justify-content-between">
          <div>
            <h5>{Utility.upperCase(globalContext.translations.discount)}</h5>
          </div>
          <div>
            <h5>
              <AmountProvider
                amount={booking.totalRemise}
                currency={booking.currency}
              />
            </h5>
          </div>
        </div>
      )}
      {/* Correction tarif */}
      {booking.correctionTarif !== 0 && (
        <div className="d-flex mb-3 justify-content-between">
          <div>
            <h5>
              {Utility.upperCase(globalContext.translations.correctionTarif)}
            </h5>
          </div>
          <div>
            <h5>
              <AmountProvider
                amount={booking.correctionTarif}
                currency={booking.currency}
              />
            </h5>
          </div>
        </div>
      )}
      {/* Prix total */}
      <div className="pt-2 d-flex justify-content-between">
        <div>
          <h4 className="text-primary">
            {Utility.upperCase(globalContext.translations.amount)}
            <Button
              className="ml-2"
              onClick={handleClickAllDetails}
              icon
              basic
              compact
              size="mini"
            >
              <Icon name="help" />
            </Button>
          </h4>
        </div>
        <div>
          <h4 className="text-primary">
            <AmountProvider
              amount={totalPrice}
              currency={booking.currency}
            />
          </h4>
        </div>
      </div>
    </>
  );
};

export default BookingPriceInfos